import { default as React, FunctionComponent } from 'react'

import { Address } from '../../../domain'
import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const AddressFormatter: FunctionComponent<Formatter<Address>> = ({ value, t }) => (
  <>{value ? value.label : t(tDefaults('inputs.no-answer'))}</>
)
